import { Link } from 'react-router-dom';

/**
 * Brand mark + Roman-engraving wordmark (Cinzel) used in app headers.
 *
 *  ┌────┐   1:2000              ← bold serif caps, sized big
 *  │ ◯ │   C L U B              ← lighter, wide letter-spaced
 *  └────┘   ─── ODDS FAVOR PLAYERS ───   ← micro caps with hairline rules
 *
 * Notes:
 *  - Logo mark uses `h-12 w-auto` so the natural rectangular artwork
 *    keeps its aspect ratio (no squish).
 *  - All copy uses Cinzel (carved-stone luxury) loaded via Google Fonts.
 *  - Colors locked to dashboard palette: #cba135 / #e6be4b / #0e0b04.
 */
const CINZEL = "'Cinzel', serif";

const BrandLogo = ({
  to,
  className = '',
}) => {
  const inner = (
    <div className={`flex items-center gap-4 leading-none ${className}`} data-testid="site-logo">
      <img
        src="/brand/logo-mark-128.png"
        srcSet="/brand/logo-mark-128.png 1x, /brand/logo-mark.png 2x"
        alt="1:2000 Club"
        width={48}
        height={48}
        className="h-12 w-12 select-none shrink-0 drop-shadow-[0_2px_8px_rgba(203,161,53,0.28)]"
        draggable="false"
      />

      <div className="flex flex-col items-start leading-none">
        <span
          className="text-[#e6be4b]"
          style={{ fontFamily: CINZEL, fontWeight: 600, fontSize: '22px', letterSpacing: '1.5px' }}
        >
          1:2000
        </span>

        <span
          className="text-[#cba135] mt-1.5"
          style={{ fontFamily: CINZEL, fontWeight: 400, fontSize: '14px', letterSpacing: '8px' }}
        >
          CLUB
        </span>

        <div className="flex items-center gap-2 mt-2">
          <span className="h-[1px] w-4 bg-[#cba135]/40" aria-hidden />
          <span
            className="uppercase text-[#cba135]/65 whitespace-nowrap"
            style={{ fontFamily: CINZEL, fontWeight: 400, fontSize: '8px', letterSpacing: '2.8px' }}
          >
            Odds favor players
          </span>
          <span className="h-[1px] w-4 bg-[#cba135]/40" aria-hidden />
        </div>
      </div>
    </div>
  );

  if (to) {
    return (
      <Link to={to} className="no-underline" data-testid="site-logo-link">
        {inner}
      </Link>
    );
  }
  return inner;
};

export default BrandLogo;
